import {$http} from '@/utils/https'
import {
    CHANGE_CATEGORIES_LOADING,
    CHANGE_CATEGORY,
    CHANGE_LOADING,
    CHANGE_SKIP,
    SET_CATEGORIES,
    SET_ITEM,
    SET_LIST,
    SET_LIST_LENGTH
} from '../mutation-types';

import {GET_CATEGORIES, GET_LIST, GET_LIST_ITEM} from '../action-types';


const state = {
    list: [],
    currentItem: null,
    isLoading: false,
    categories: [],
    isLoadingCategories: false,
    skip: 0,
    limit: 9,
    listLength: 0,
    activeCategory: ''
};

const getters = {
    list: state => state.list,
    currentItem: state => state.currentItem,
    listLength: state => state.listLength,
    skip: state => state.skip,
    limit: state => state.limit,
    isLoading: state => state.isLoading,
    categories: state => state.categories,
    isLoadingCategories: state => state.isLoadingCategories,
};

const actions = {
    [GET_CATEGORIES]: async ({commit}) => {
        try {
            commit(CHANGE_CATEGORIES_LOADING, true)
            const response = await $http.get(`${process.env.VUE_APP_ROOT_NEWS}categories`);

            commit(SET_CATEGORIES, response.data.data);
            return response;
        } catch (e) {
            throw e;
        } finally {
            commit(CHANGE_CATEGORIES_LOADING, false)
        }
    },
    [GET_LIST]: async ({commit}, payload) => {
        try {
            commit(CHANGE_LOADING, true);

            if (payload.isResetList) {
                commit(SET_LIST, []);
                commit(CHANGE_SKIP, true)
            } else commit(CHANGE_SKIP);

            const response = await $http.get(`${process.env.VUE_APP_ROOT_NEWS}news?include=image,categories,tags,content,picture,picture.seo&limit=${state.limit}&skip=${state.skip}&filters[categories]=${state.activeCategory}`);
            payload.isResetList && commit(SET_LIST, []);
            commit(SET_LIST, response.data.data);
            commit(SET_LIST_LENGTH, response.data.meta.total);
            return response;
        } catch (e) {
            throw e;
        } finally {
            commit(CHANGE_LOADING, false);
        }
    },
    [GET_LIST_ITEM]: async ({commit}, payload) => {
        try {
            commit(CHANGE_LOADING, true);

            const response = await $http.get(`${process.env.VUE_APP_ROOT_NEWS}news/${payload.slug}?include=seo,contents,positions,image,categories,tags,categories.content,tags.content,cover,cover.seo&use_as_id=slug`);
            commit(SET_ITEM, response.data.data);
            return response;
        } catch (e) {
            throw e;
        } finally {
            commit(CHANGE_LOADING, false);
        }
    },
};

const mutations = {
    [SET_LIST](state, data) {
        if (!data) return;
        if (state.list) {
            state.list.push(...data);
        } else {
            state.list = data;
        }
    },
    [SET_LIST_LENGTH](state, length) {
        state.listLength = length;
    },
    [SET_CATEGORIES](state, data) {
        state.categories = data;
    },
    [CHANGE_SKIP](state, status) {
        if (status) {
            state.skip = 0
        } else {
            state.skip += state.limit;
        }
    },
    [SET_ITEM](state, data) {
        if (data && data.hasOwnProperty('authors')) {
            data.speakers = data.authors
        }
        state.currentItem = data;
    },
    [CHANGE_LOADING](state, status) {
        state.isLoading = status;
    },
    [CHANGE_CATEGORIES_LOADING](state, status) {
        state.isLoadingCategories = status;
    },
    [CHANGE_CATEGORY](state, category = '') {
        state.activeCategory = category;
        state.skip = 0;
        state.listLength = 0;
        state.list = [];
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
